export const Endpoint = {
  accounts: {
    resetPassword: '/v1/api/accounts/reset-password/:uidb64/:token',
    passkeyAuthenticationOptions: '/v1/api/accounts/passkeys/authentication/options',
    passkeyAuthenticationVerify: '/v1/api/accounts/passkeys/authentication/verify',
  },
  widgetSettings: '/v1/api/widget/configuration',
  widgetTranslations: '/v1/api/widget/configuration/translations',
  widgetTranslationsGenerate: '/v1/api/widget/configuration/translations/generate',
  installInstructions: '/v1/api/widget/install-instructions/send',
  conversationStarters: {
    generate: '/v1/api/conversation_starters/generate',
  },
  chatPageAccess: '/v1/api/integration/chat_page_access',
  publicUrl: '/v1/api/integration/public_url',
  changelog: {
    list: 'https://quickchat.ai/releases.json',
  },
  knowledgeBase: {
    articles: {
      listOrFilter: '/v1/api/knowledge_base/articles/',
      delete: '/v1/api/knowledge_base/articles/',
      create: '/v1/api/knowledge_base/articles/',
      update: '/v1/api/knowledge_base/articles/:articleId',
      autoRefresh: '/v1/api/knowledge_base/articles/:articleId/auto_refresh',
      autoRefreshBulk: '/v1/api/knowledge_base/articles/auto_refresh',
      refresh: '/v1/api/knowledge_base/articles/:articleId/refresh',
      refreshUrlArticles: '/v1/api/knowledge_base/articles/refresh_url_articles',
      uploadFile: '/v1/api/knowledge_base/file_upload_api',
      autoTag: '/v1/api/knowledge_base/auto_tag/articles/:articleId',
      autoTagBulk: '/v1/api/knowledge_base/auto_tag/articles',
    },
    autoRefresh: '/v1/api/knowledge_base/auto_refresh',
    retryFailedEmbeds: '/v1/api/knowledge_base/retry_failed_embeds',
    paragraphs: '/v1/api/knowledge_base/articles/paragraphs',
    website: {
      singlePage: '/v1/api/knowledge_base/import_external/website',
      multiplePages: '/v1/api/knowledge_base/import_external/scrape-list',
      sitemap: '/v1/api/knowledge_base/import_external/site-map',
      allPages: '/v1/api/knowledge_base/import_external/website',
    },
    siteMapPreview: {
      start: '/v1/api/knowledge_base/import_external/site-map/preview/start',
      get: '/v1/api/knowledge_base/import_external/site-map/preview',
      selection: '/v1/api/knowledge_base/import_external/site-map/preview/selection',
      scrape: '/v1/api/knowledge_base/import_external/site-map/preview/scrape',
      children: '/v1/api/knowledge_base/import_external/site-map/preview/children',
      delete: '/v1/api/knowledge_base/import_external/site-map/preview',
    },
    syncedSites: {
      list: '/v1/api/knowledge_base/synced_sites/',
      suggestions: '/v1/api/knowledge_base/synced_sites/suggestions',
      update: '/v1/api/knowledge_base/synced_sites/:siteId',
      scope: '/v1/api/knowledge_base/synced_sites/:siteId/scope',
      scopeChildren: '/v1/api/knowledge_base/synced_sites/:siteId/scope/children',
      recentAdditions: '/v1/api/knowledge_base/synced_sites/:siteId/recent_additions',
      missingPages: '/v1/api/knowledge_base/synced_sites/:siteId/missing_pages',
      sync: '/v1/api/knowledge_base/synced_sites/:siteId/sync',
    },
    tags: '/v1/api/knowledge_base/tags/',
    tagsSearch: '/v1/api/knowledge_base/tags/search',
    import: {
      youtubeVideo: '/v1/api/knowledge_base/import_external/youtube',
    },
    intercom: {
      import: '/v1/api/knowledge_base/intercom/import',
      refresh: '/v1/api/knowledge_base/intercom/refresh_articles',
      delete: '/v1/api/knowledge_base/intercom/delete',
    },
  },
  sonyAdmin: {
    documents: '/v1/api/sony/admin/documents',
    document: '/v1/api/sony/admin/documents/:externalId',
    documentPatch: '/v1/api/sony/admin/documents/:externalId',
    runPipeline: '/v1/api/sony/admin/documents/:externalId/run_pipeline',
    deployLive: '/v1/api/sony/admin/documents/:externalId/deploy_live',
    article: '/v1/api/sony/admin/articles/:externalId',
  },
  app: {
    bootstrap: '/v1/api/app/bootstrap',
    supportIdentityToken: '/v1/api/app/support_identity_token',
    supportReplyNotificationsPending: '/v1/api/app/support_reply_notifications/pending',
    supportReplyNotificationsSeen: '/v1/api/app/support_reply_notifications/seen',
  },
  user: {
    myself: '/v1/api/accounts/me',
    update: '/v1/api/accounts/me',
    email: '/v1/api/accounts/me/email',
    avatar: '/v1/api/accounts/me/avatar',
    passkeys: '/v1/api/accounts/me/passkeys',
    passkey: '/v1/api/accounts/me/passkeys/:passkeyId',
    passkeyRegistrationOptions: '/v1/api/accounts/me/passkeys/registration/options',
    passkeyRegistrationVerify: '/v1/api/accounts/me/passkeys/registration/verify',
    deleteAccount: '/v1/api/accounts/me/delete',
  },
  ai: {
    users: '/v1/api/scenario_users',
    transferOwnership: '/v1/api/scenario_users/:userId/transfer_ownership',
    assistant: '/v1/api/ai_assistants',
    model: '/v1/api/ai_model',
  },
  implementation: {
    delete: '/delete_implementation',
  },
  conversation: {
    list: '/v1/api_core/conversations',
    get: '/v1/api_core/conversations/:conversationId/',
    details: '/v1/api_core/conversations/:conversationId/details',
    update: '/v1/api_core/conversations/:conversationId/',
    reply: `/v1/api_core/conversations/:conversationId/reply/`,
    visitor: '/v1/api_core/conversations/:conversationId/visitor',
    whyAISaidThat:
      '/v1/api_core/conversations/:conversationId/messages/:messageId/why_ai_said_that',
    messageFeedback: '/v1/api_core/conversations/:conversationId/messages/:messageId/feedback',
    translate: `/v1/api_core/conversations/:conversationId/translate`,
    rating: '/v1/api_core/conversations/:conversationId/ratings',
    sendTemplate: '/v1/api_core/conversations/:conversationId/send_template/',
    sendMedia: '/v1/api_core/conversations/:conversationId/send_media/',
  },
  whatsappPhoneNumbers: {
    list: '/v1/api/whatsapp_phone_numbers/',
    toggle: '/v1/api/whatsapp_phone_numbers/toggle/',
    test: '/v1/api/whatsapp_phone_numbers/test/', // Pre-built for upcoming test-message UI
    delete: '/v1/api/whatsapp_phone_numbers/',
    status: '/v1/api/whatsapp_phone_numbers/status/',
    oauthState: '/v1/api/whatsapp_phone_numbers/oauth-state/',
    pendingAccounts: '/v1/api/whatsapp_phone_numbers/pending_accounts/',
    pendingAccountSelect: '/v1/api/whatsapp_phone_numbers/pending_accounts/select/',
    pendingAccountCancel: '/v1/api/whatsapp_phone_numbers/pending_accounts/cancel/:stageId/',
    oauthResult: '/v1/api/whatsapp_phone_numbers/oauth-result/:attemptId/',
  },
  whatsappTemplates: {
    list: '/v1/api/whatsapp_templates/',
    sendBulk: '/v1/api/whatsapp_templates/send_bulk/',
    validatePhones: '/v1/api/whatsapp_templates/validate_phones/',
  },
  userOptions: {
    inboxTranslation: '/v1/api/user_options/inbox_translation',
  },
  emailSummaries: {
    activitySummary: '/v1/api/email_summaries/activity_summary',
    marketingConsent: '/v1/api/email_summaries/marketing_consent',
  },
  conversationTopics: {
    list: '/v1/api/conversation_topics',
    create: '/v1/api/conversation_topics',
    get: '/v1/api/conversation_topics/:conversationTopicId',
    upload: '/v1/api/conversation_topics/:conversationTopicId',
    delete: '/v1/api/conversation_topics/:conversationTopicId',
  },
  conversationAnalysisAlerts: {
    list: '/v1/api/conversation_analysis_alerts',
    create: '/v1/api/conversation_analysis_alerts',
    get: '/v1/api/conversation_analysis_alerts/:alertId',
    update: '/v1/api/conversation_analysis_alerts/:alertId',
    delete: '/v1/api/conversation_analysis_alerts/:alertId',
  },
  subscription: {
    list: '/v1/api/offer/',
    get: '/v1/api/subscription/',
    manage: '/payments/create-billing-portal-session/',
    cancel: '/payments/change-subscription/',
    update: '/payments/handle-subscription/',
    draft: '/payments/draft_subscription/',
    usage: '/v1/api/subscription/message_usage',
    creditTopup: '/v1/api/subscription/credit_topup',
    creditTopupCheckout: '/v1/api/subscription/credit_topup/checkout',
    creditTopupAutoReload: '/v1/api/subscription/credit_topup/auto_reload',
    creditTopupCardSetup: '/v1/api/subscription/credit_topup/auto_reload/card',
  },

  actions: {
    basic: {
      list: '/v1/api/ai_actions/',
      patch: '/v1/api/ai_actions/:actionId',
      delete: '/v1/api/ai_actions/:actionId',
      duplicate: '/v1/api/ai_actions/:actionId/duplicate',
      stats: '/v1/api/ai_actions/stats',
      health: '/v1/api/ai_actions/health',
      calls: '/v1/api/ai_actions/:actionId/calls',
      skips: '/v1/api/ai_actions/:actionId/skips',
      observed_metadata_keys: '/v1/api/ai_actions/observed-metadata-keys',
    },
    httpRequest: {
      create: '/v1/api/ai_actions/http_request',
      get: '/v1/api/ai_actions/:actionId/http_request',
      update: '/v1/api/ai_actions/:actionId/http_request',
      test: '/v1/api/ai_actions/http_request/test',
      from_text: '/v1/api/ai_actions/http_request/from_text',
    },
    discordTemplates: {
      guilds: '/v1/api/ai_actions/discord_templates/guilds',
      resources: '/v1/api/ai_actions/discord_templates/guilds/:guildId',
      install: '/v1/api/ai_actions/discord_templates/install',
    },
    shopifyMcp: {
      create: '/v1/api/ai_actions/shopify_remote_mcp',
      get: '/v1/api/ai_actions/:actionId/shopify_remote_mcp',
      update: '/v1/api/ai_actions/:actionId/shopify_remote_mcp',
      test: '/v1/api/ai_actions/shopify_remote_mcp/test',
    },
    remoteMcp: {
      create: '/v1/api/ai_actions/remote_mcp/tool-memory',
      get: '/v1/api/ai_actions/:actionId/remote_mcp',
      update: '/v1/api/ai_actions/:actionId/remote_mcp/tool-memory',
      connect: '/v1/api/ai_actions/remote_mcp/connect',
      oauthStart: '/v1/api/ai_actions/:actionId/remote_mcp/oauth/start',
      oauthDisconnect: '/v1/api/ai_actions/:actionId/remote_mcp/oauth/revoke',
    },
    knowledgeBase: {
      create: '/v1/api/ai_actions/knowledge_base',
      get: '/v1/api/ai_actions/:actionId/knowledge_base',
      update: '/v1/api/ai_actions/:actionId/knowledge_base',
    },
  },
  campaigns: {
    list: '/v1/api/campaigns',
    get: '/v1/api/campaigns/:campaignId',
    update: '/v1/api/campaigns/:campaignId',
  },
  handoff: {
    get: '/v1/api/human_handoff/configuration',
    put: '/v1/api/human_handoff/configuration',
  },
  shopify: {
    editorLink: '/v1/api/shopify/editor_link',
    oauth: '/v1/api/shopify/oauth',
  },
  mcp: {
    get: '/v1/api/mcp/settings',
    patch: '/v1/api/mcp/settings',
  },
  channelIdentity: {
    list: '/v1/api/channel_identity',
    whatsappLink: '/v1/api/channel_identity/whatsapp/link',
    revoke: '/v1/api/channel_identity/:channelIdentityId',
  },
  inboxStatus: {
    general: '/v1/api_core/inbox_status',
    my: '/v1/api_core/inbox_status/my',
  },
  export: {
    conversations: '/v1/api_core/export/conversations',
    conversationJob: '/v1/api_core/export/conversations/:jobId',
    dataGathering: '/v1/api_core/export/data_gathering',
    dataGatheringJob: '/v1/api_core/export/data_gathering/:jobId',
    linkTracking: '/v1/api_core/export/link_tracking',
    aiInsights: '/v1/api_core/export/ai_insights',
    triageData: '/v1/api_core/export/sony_triage_data',
    kbSources: '/v1/api_core/export/kb_sources',
  },
  analytics: {
    general: '/v1/api_core/dashboard/analytics',
    conversationRating: '/v1/api_core/dashboard/analytics/conversation_rating',
    linkTracking: '/v1/api_core/dashboard/link_tracking',
    kbSources: '/v1/api_core/dashboard/kb_sources',
    kbSourcesExamples: '/v1/api_core/dashboard/kb_sources/:articleId/examples',
    userIntentDistribution: '/v1/api_core/dashboard/unified_insights/user_intent_distribution',
    unifiedInsightsList: '/v1/api_core/dashboard/unified_insights/list',
    setInsightReviewed: '/v1/api_core/dashboard/unified_insights/set_reviewed',
    markAllInsightsReviewed: '/v1/api_core/dashboard/unified_insights/mark_all_reviewed',
    unreadInsightsCount: '/v1/api_core/dashboard/unified_insights/unread_count',
    sourceUrls: '/v1/api_core/dashboard/source_urls',
    externalCsat: '/v1/api_core/dashboard/analytics/external_csat',
    ttfr: '/v1/api_core/dashboard/analytics/ttfr',
  },
  conversationRatingConfiguration: {
    get: '/v1/api/conversation_ratings/configuration',
    patch: '/v1/api/conversation_ratings/configuration',
    surveySettings: '/v1/api/conversation_ratings/survey_settings',
    surveySettingsPatch: '/v1/api/conversation_ratings/survey_settings',
  },
  aiAssistants: {
    get: '/v1/api/ai_assistants',
    dismissReviewPrompt: '/v1/api/ai_assistants/dismiss_review_prompt',
    clone: '/v1/api/ai_assistants/clone',
    cloneStatus: '/v1/api/ai_assistants/clone/:jobId',
    cloneCheckout: '/v1/api/ai_assistants/clone/checkout',
  },
  integration: {
    // Generic GET (per-integration) and PATCH (any integration) used by all
    // channel-integration sheets (Discord/Telegram/SlackLegacy/...).
    get: '/v1/api/integration/:name',
    patch: '/v1/api/integration/',
    autoCloseMinutes: '/v1/api/integration/auto-close-minutes',
    hubspotTokenStatus: '/v1/api/integration/hubspot/token-status',
    hubspotResolutionSurvey: '/v1/api/integration/hubspot/resolution-survey',
    hubspotEmailReplyDelay: '/v1/api/integration/hubspot/email-reply-delay',
    hubspotOauth: '/v1/api/integration/hubspot/oauth',
    hubspotPipelines: '/v1/api/hubspot/pipelines',
    hubspotWhatsappTemplate: '/v1/api/hubspot/whatsapp-template',
    googleSheetsStatus: '/v1/api/integration/google-sheets/token-status',
    googleSheetsOauth: '/v1/api/integration/google-sheets/oauth',
    discordTokenStatus: '/v1/api/integration/discord/token-status',
    discordBotInfo: '/v1/api/integration/discord/bot-info',
    discordValidateToken: '/v1/api/integration/discord/validate-token',
    discordOauth: '/v1/api/integration/discord/oauth',
    discordGuilds: '/v1/api/integration/discord/guilds',
    discordGuildsHealth: '/v1/api/integration/discord/guilds-health',
    discordGuild: '/v1/api/integration/discord/guilds/:guild_id',
    discordAutomatedMessageOptions:
      '/v1/api/integration/discord/guilds/:guild_id/automated-message-options',
    discordAutomatedMessages: '/v1/api/integration/discord/guilds/:guild_id/automated-messages',
    discordAdvancedGuilds: '/v1/api/integration/discord/advanced/guilds',
    discordAdvancedAutomatedMessageOptions:
      '/v1/api/integration/discord/advanced/guilds/:guild_id/automated-message-options',
    discordAdvancedAutomatedMessages:
      '/v1/api/integration/discord/advanced/guilds/:guild_id/automated-messages',
    telegramOneClickAvailability: '/v1/api/integration/telegram/availability',
    telegramConnectLink: '/v1/api/integration/telegram/connect-link',
    telegramChats: '/v1/api/integration/telegram/chats',
    telegramChat: '/v1/api/integration/telegram/chats/:chat_id',
    telegramChatConfirm: '/v1/api/integration/telegram/chats/:chat_id/confirm',
    telegramDirectLink: '/v1/api/integration/telegram/direct-link',
    telegramBotInfo: '/v1/api/integration/telegram/bot-info',
    intercomValidateToken: '/v1/api/integration/intercom/validate-token',
    intercomRemove: '/v1/api/integration/intercom/remove',
    emailConnect: '/v1/api/integration/email/connect',
    emailReplyAddress: '/v1/api/integration/email/reply-address',
    emailVerifyDomain: '/v1/api/integration/email/verify-domain',
    emailSettings: '/v1/api/integration/email/settings',
    emailRemove: '/v1/api/integration/email/remove',
    facebookMessengerDelete: '/v1/api/integration/facebook_messenger/delete',
    messengerOauthState: '/v1/api/integration/messenger/oauth-state',
    messengerPages: '/v1/api/integration/messenger/pages',
    messengerPageSelect: '/v1/api/integration/messenger/pages/select',
    instagramOauthState: '/v1/api/integration/instagram/oauth-state',
    instagramHealth: '/v1/api/integration/instagram/health',
    instagramDelete: '/v1/api/integration/instagram/delete',
    slackV2Oauth: '/v1/api/integration/slackv2/oauth',
    slackV2Revoke: '/v1/api/integration/slackv2/revoke',
    // Zendesk goes through telegramquickchat via the legacy Django proxy.
    // `:scenarioId` is filled per-call.
    zendesk: '/api/integrations/api/v1/zendesk/:scenarioId',
  },
  apiTokens: {
    list: '/v1/api/auth/tokens/quickchat-app',
    create: '/v1/api/auth/tokens/quickchat-app',
    revoke: '/v1/api/auth/tokens/quickchat-app/revoke',
    legacyInfo: '/v1/api/auth/tokens/legacy-info',
  },
  onboarding: {
    progress: '/v1/api/onboarding_progress',
    trackPageVisit: '/v1/api/onboarding_progress/track_page_visit',
    fromUrl: '/v1/api/chatbot_settings/onboard-from-url',
    fromDescription: '/v1/api/chatbot_settings/onboard-from-description',
    descriptionStatus: '/v1/api/chatbot_settings/onboard-from-description/:runId',
  },
  gettingStarted: {
    progress: '/v1/api/getting_started_progress',
    discount: '/v1/api/getting_started_progress/discount',
  },
  invites: {
    mine: '/v1/api/scenario_users/invites/my_invites',
    accept: '/v1/api/scenario_users/invites/accept/:token',
    ignore: '/v1/api/scenario_users/invites/ignore_and_create_implementation',
    destroy: '/v1/api/scenario_users/invites/:token',
  },
  previewWebsite: {
    get: '/v1/api/preview_website',
    refresh: '/v1/api/preview_website/refresh',
  },
  simulation: {
    datasets: '/v1/api/simulation/datasets',
    datasetDetail: '/v1/api/simulation/datasets/:datasetId',
    datasetMessages: '/v1/api/simulation/datasets/:datasetId/messages',
    uploadCsv: '/v1/api/simulation/datasets/upload_csv',
    datasetRuns: '/v1/api/simulation/datasets/:datasetId/runs',
    runDetail: '/v1/api/simulation/runs/:runId',
    runCancel: '/v1/api/simulation/runs/:runId/cancel',
    defaultEvaluationCriteria: '/v1/api/simulation/defaults/evaluation_criteria',
    recentVisitorMessages: '/v1/api/simulation/recent_visitor_messages',
  },
  conversationSources: '/v1/api/accounts/conversation_sources',
  assistedOrders: {
    summary: '/v1/api/assisted_orders/summary',
    recent: '/v1/api/assisted_orders/recent',
    availability: '/v1/api/assisted_orders/availability',
  },
  inboxSettings: {
    autoClose: '/v1/api/inbox_settings/auto-close',
    conversationBadge: '/v1/api/inbox_settings/conversation-badge',
  },
};
